import { RICH_TEXT_MAX_LIST_DEPTH } from '@lib/rich-text';
import { Extension } from '@tiptap/core';
import type { Node as ProseMirrorNode, ResolvedPos } from '@tiptap/pm/model';
import { Plugin } from '@tiptap/pm/state';

const LIST_TYPES = new Set(['bulletList', 'orderedList']);

const isList = (node: ProseMirrorNode) => LIST_TYPES.has(node.type.name);

const listDepthAt = ($pos: ResolvedPos): number => {
  let depth = 0;
  for (let level = $pos.depth; level > 0; level -= 1) {
    if (isList($pos.node(level))) depth += 1;
  }
  return depth;
};

const maxListDepth = (node: ProseMirrorNode): number => {
  if (node.isTextblock) return 0;
  let deepest = 0;
  node.forEach((child) => {
    deepest = Math.max(deepest, (isList(child) ? 1 : 0) + maxListDepth(child));
  });
  return deepest;
};

export const listDepthLimit = Extension.create({
  name: 'listDepthLimit',
  priority: 1000,

  addKeyboardShortcuts() {
    return {
      Tab: ({ editor }) => listDepthAt(editor.state.selection.$from) >= RICH_TEXT_MAX_LIST_DEPTH,
    };
  },

  addProseMirrorPlugins() {
    return [
      new Plugin({
        filterTransaction: (transaction, state) => {
          if (!transaction.docChanged) return true;
          const next = maxListDepth(transaction.doc);
          return next <= RICH_TEXT_MAX_LIST_DEPTH || next <= maxListDepth(state.doc);
        },
      }),
    ];
  },
});
